import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

import type { GlossaryResponse, GlossaryTermItem } from '@/entities/glossary';

export type SearchGlossaryTermParams = {
  q?: string;
  glossaryFqn?: string;
  limit?: number;
  offset?: number;
};

export type SearchGlossaryTermResponse = GlossaryResponse<GlossaryTermItem>;

export const searchGlossaryTermApi = async ({
  q = '',
  glossaryFqn = '',
  offset = 0,
}: SearchGlossaryTermParams): Promise<SearchGlossaryTermResponse> => {
  const { data } = await openMetadataApiClient.get<SearchGlossaryTermResponse>('/glossaryTerms/search', {
    params: {
      offset,
      ...(q && { q }),
      ...(glossaryFqn && { glossaryFqn }),
      fields: 'children,relatedTerms,reviewers,owners,tags,usageCount,domains,extension,childrenCount',
    },
  });
  return data;
};
